import axios from 'axios'
import FileDownload from'js-file-download'

const api = {

  // election periods

  async getElectionPeriods () {
    return await axios.get('/api/af/electionPeriods').then(response => response.data)
  },

  async getActiveElectionPeriod () {
    return await axios.get('/api/af/electionPeriods/active').then(response => response.data)
  },

  async getElectionPeriod (id) {
    return await axios.get('/api/af/electionPeriods/' + id).then(response => response.data)
  },

  async createElectionPeriod (electionPeriod) {
    return await axios.post('/api/af/electionPeriods', electionPeriod)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updateElectionPeriod (data) {
    return await axios.put('/api/af/electionPeriods/' + data.electionPeriodId, data)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async deleteElectionPeriod (id) {
    return await axios.delete('/api/af/electionPeriods/' + id)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  // universities

  async getUniversities () {
    return await axios.get('/api/af/universities').then(response => response.data)
  },

  async getUniversity (id) {
    return await axios.get('/api/af/universities/' + id).then(response => response.data)
  },

  async createUniversity (university) {
    return await axios.post('/api/af/universities', university)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updateUniversity (university) {
    return await axios.put('/api/af/universities/' + university.universityId, university)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async deleteUniversity (universityId) {
    return await axios.delete('/api/af/universities/' + universityId)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  // pharmacies

  async getPharmacies () {
    return await axios.get('/api/af/pharmacies').then(response => response.data)
  },

async getPharmacy (id) {
    return await axios.get('/api/af/pharmacies/' + id).then(response => response.data)
  },

async createPharmacy (data) {
    return await axios.post('/api/af/pharmacies', data)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updatePharmacy (pharmacy) {
    return await axios.put('/api/af/pharmacies/' + pharmacy.pharmacyId, pharmacy)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async deletePharmacy (pharmacyId) {
    return await axios.delete('/api/af/pharmacies/' + pharmacyId)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  // chains

  async getChains () {
    return await axios.get('/api/af/chains').then(response => response.data)
  },

  async getChain (id) {
    return await axios.get('/api/af/chains/' + id).then(response => response.data)
  },

  async createChain (chain) {
    return await axios.post('/api/af/chains', chain)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updateChain (chain) {
    return await axios.put('/api/af/chains/' + chain.chainId, chain)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async deleteChain (chainId) {
    return await axios.delete('/api/af/chains/' + chainId)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  // users

  async getUsers () {
    return await axios.get('/api/af/users').then(response => response.data)
  },

  async getUsersByRole (role) {
    return await axios.get('/api/af/users?role=' + encodeURIComponent(role)).then(response => response.data)
  },

  async getUser (id) {
    return await axios.get('/api/af/users/' + id).then(response => response.data)
  },

  async createUser (user) {
    return await axios.post('/api/af/users', user)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updateUser (user) {
    return await axios.put('/api/af/users/' + user.userId, user)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async deleteUser (userId) {
    return await axios.delete('/api/af/users/' + userId)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async getChainContactUsers () {
    return await axios.get('/api/af/users/chaincontacts').then(response => response.data)
  },

  // email templates

  async getEmailTemplates () {
    return await axios.get('/api/af/emailTemplates').then(response => response.data)
  },

  async getEmailTemplate (id) {
    return await axios.get('/api/af/emailTemplates/' + id).then(response => response.data)
  },

  async createEmailTemplate (emailTemplate) {
    return await axios.post('/api/af/emailTemplates', emailTemplate)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  async updateEmailTemplate (emailTemplate) {
    return await axios.put('/api/af/emailTemplates/' + emailTemplate.emailTemplateId, emailTemplate)
    .then(response => response.data)
    .catch(error => error.response.data)
  },

  // messages

  async getMessages (skip, take) {
    return await axios.get(`/api/af/emailmessages?skip=${skip}&take=${take}`).then(response => response.data)
  },

  async getMessage (messageId) {
    return await axios.get(`/api/af/emailmessages/${messageId}`).then(response => response.data)
  },

  // home

  async getPracticePeriodsByUniversity () {
    return await axios.get('/api/af/practiceperiods/byuniversity').then(response => response.data)
  },

  // depricated
  async getChainStats () {
    return await axios.get('/api/af/practiceslots/chainstats').then(response => response.data)
  },

  async getTotalSlotCount () {
    return await axios.get('/api/af/practiceslots/totalslotcount').then(response => response.data)
  },

  async getChainStats2 () {
    return await axios.get('/api/af/practiceslots/chainstats2').then(response => response.data)
  },

  async getUniversityStudentCounts () {
    return await axios.get('/api/af/universities/studentcounts').then(response => response.data)
  },

  async getSpecialStats () {
    return await axios.get('/api/af/practiceslots/specialstats').then(response => response.data)
  },

  async getSpecialDetailedStats () {
    return await axios.get('/api/af/practiceslots/specialdetailedstats').then(response => response.data)
  },

  async getWishStats () {
    return await axios.get('/api/af/wishes/stats').then(response => response.data)
  },

  async getWishStatDetails () {
    return await axios.get('/api/af/wishes/statDetails').then(response => response.data)
  },

  async createEmailMessage (data) {
    return await axios.post('/api/af/emailMessages', data).then(response => response.data)
  },

  async createSmsMessage (data) {
    return await axios.post('/api/af/smsMessages', data).then(response => response.data)
  },

  async createDraw () {
    return await axios.post('/api/af/draw').then(response => response.data)
  },

  async getDrawResults () {
    return await axios.get('/api/af/draw/results').then(response => response.data)
  },

  exportDrawResults () {
    axios.get('/api/af/draw/export', { responseType: 'blob' }).then((response) => {
      FileDownload(response.data, 'resultat.xlsx')
    })
  },

  exportAvailable () {
    axios.get('/api/af/draw/available', { responseType: 'blob' }).then((response) => {
      FileDownload(response.data, 'ledige_praksisplasser.xlsx')
    })
  },


  // task statuses

  async getTaskStatuses () {
    return await axios.get('/api/af/taskStatuses').then(response => response.data)
  },

  async createTaskStatus (taskId) {
    return await axios.post('/api/af/taskStatuses', { taskId }).then(response => response.data)
  },

  // students

  async deleteStudent (studentId) {
    return await axios.delete('/api/af/students/' + studentId)
    .then(response => response.data)
    .catch(error => error.response.data)

  },

  // practice slots

  async getAvailablePracticeSlots (study) {
    return await axios.get('/api/af/practiceslots/available/' + study).then(response => response.data)
  },

  async assignPracticeSlot (studentId, practiceSlotId) {
    return await axios.post('/api/af/practiceSlots/assign', { studentId, practiceSlotId }).then(response => response.data)
  },


  // other

  async updateElectionPeriodActiveStep (index) {
    return await axios.post('/api/af/electionPeriods/activeStep', { index })
  },

  async resetTestData () {
    await axios.get('/api/af/tests/remove-test-data')
    return await axios.get('/api/af/tests/add-test-data')
  }

}

export default api